const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;

let socket = null;
let messageHandler = null;

const connect = (userId, handler) => {
  if (socket) {
    socket.close();
  }

  messageHandler = handler;

  socket = new WebSocket(`${WEBSOCKET_URL}/api/ws/${userId}`);

  socket.onopen = () => {
    console.log("WebSocket connected");
  };

  socket.onmessage = (event) => {
    if (messageHandler) {
      messageHandler(event.data);
    }
  };

  socket.onclose = () => {
    console.log("WebSocket disconnected");
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };
};

const sendMessage = (message) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
  } else {
    console.error("WebSocket is not connected");
  }
};

const disconnect = () => {
  if (socket) {
    socket.close();
    socket = null;
    messageHandler = null;
  }
};

export { connect, sendMessage, disconnect };
